import { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import $ from 'jquery';
import 'magnific-popup';

const StudentNotification = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    // Refs to track up-to-date state inside scroll handler
    const offsetRef = useRef(0);
    const loadingRef = useRef(false);
    const hasMoreRef = useRef(true);

    const fetchNotifications = useCallback(async () => {
        if (loadingRef.current || !hasMoreRef.current) return;

        loadingRef.current = true;
        setLoading(true);

        try {
            const res = await axios.get("/api/student/get-student-notification", {
                params: { offset: offsetRef.current }
            });

            const newNotifications = res.data.data || [];

            setNotifications((prev) => [...prev, ...newNotifications]);

            if (newNotifications.length < 10) {
                setHasMore(false);
                hasMoreRef.current = false;
            } else {
                offsetRef.current += 10;
            }
        } catch (err) {
            console.error("Error fetching notifications", err);
        }

        setLoading(false);
        loadingRef.current = false;
    }, []);

    useEffect(() => {
        fetchNotifications(); // Load first 10 notifications
    }, [fetchNotifications]);

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop + 50 >=
                document.documentElement.scrollHeight
            ) {
                fetchNotifications();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [fetchNotifications]);

    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-10 bg-base border border-end-0 border-start-0 border-top-0">
                        <h3 className="mb-0">Notification</h3>
                    </div>
                    <div className="card-body p-10 pt-10">
                        {notifications.map((item, index) => (
                            <div key={index} className="notification-card mb-3">
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Send Date </label>: {new Date(item.added_date).toLocaleString()}
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Sended By </label>: {item.User?.first_name} {item.User?.last_name}
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Message </label>: {item.message}
                                    </div>
                                </div>
                                {item.image && (
                                    <div className="row gy-3">
                                        <div className="col-12 text-center">
                                        {(() => {
                                            const fileUrl = `${process.env.REACT_APP_BASE_SITE_URL}/uploads/attachments/${item.image}`;
                                            const ext = item.image.split(".").pop().toLowerCase();
                                            const anchorId = `popup-link-${index}`; // unique ID for each anchor

                                            if (ext === "pdf") {
                                            return (
                                                <button
                                                className="btn btn-primary"
                                                style={{ fontWeight: 700 }}
                                                onClick={() => window.open(fileUrl, "_blank")}
                                                >
                                                View PDF
                                                </button>
                                            );
                                            } else {
                                            return (
                                                <>
                                                {/* Hidden anchor tag that triggers popup */}
                                                <a
                                                    id={anchorId}
                                                    href={fileUrl}
                                                    className="popup-link"
                                                    style={{ display: "none" }}
                                                >
                                                    Open Image
                                                </a>

                                                {/* Visible button that triggers anchor programmatically */}
                                                <button
                                                    className="btn btn-primary"
                                                    style={{ fontWeight: 700 }}
                                                    onClick={() => $(`#${anchorId}`).magnificPopup({ type: 'image', closeOnContentClick: true,image: { verticalFit: true } }).magnificPopup('open')}
                                                >
                                                    View Document
                                                </button>
                                                </>
                                            );
                                            }
                                        })()}
                                        </div>
                                    </div>
                                )}

                            </div>
                        ))}
                        {loading && <p>Loading...</p>}
                        {!hasMore && <p className="error">No more notifications</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentNotification;